import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-trading',
  templateUrl: './page-trading.component.html',
  styleUrls: ['./page-trading.component.css']
})

/**
 * page Blog-Detail-Two Component
 */
export class PageTradingComponent implements OnInit {

      // Set Topbar Option
  Menuoption = 'center';
  Settingicon = false;
  /**
   * Nav Light Class Add
   */
  navClass = 'nav-light';

  constructor() { }

  ngOnInit(): void {
  }


}
